/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportMutationDtoMutationStatus =
  (typeof LabReportMutationDtoMutationStatus)[keyof typeof LabReportMutationDtoMutationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportMutationDtoMutationStatus = {
  YES: 'YES',
  WILDTYPE: 'WILDTYPE',
  NOT_MADE: 'NOT_MADE',
} as const;
